import * as icons from '../icon/assets';

interface IconProps {
  name: keyof typeof icons;
  size: number;
  color: string;
  wrapperStyle?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
}

export const iconNames = Object.keys(icons);

export function Icon({ name, size, color, wrapperStyle, onClick, className }: IconProps) {
  const Icon = icons[name];

  return (
    <div style={{ ...wrapperStyle }} onClick={onClick} className={className}>
      <Icon style={{ width: size, height: size, color }} />
    </div>
  );
}
